import { createAsyncThunk } from "@reduxjs/toolkit";
import apiRequest from "services/ApiProvider";
import { API_BASE_URL, API_BASE_URL_FILE, AUTH_TOKEN } from "configs/AppConfig";

// first define initialState
export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
};
//==================  2f start ==================
//================== Generate 2FA QR function start ==================
export const generate2FA = async (data_parama) => {
  apiRequest.consoleProvider("data", data_parama);
  try {
    const response = await apiRequest.post(API_BASE_URL + "/auth/generate2FA", data_parama, "");
    apiRequest.consoleProvider("response return");
    if (response.success === true) {
      apiRequest.consoleProvider("response success");
      const msg = response.msg;
      const data = response.data;
      apiRequest.consoleProvider("message", msg);
      return { success: true, msg: msg, data: data };
    } else {
      apiRequest.consoleProvider("response false");
      const msg = response.msg;
      apiRequest.consoleProvider("message", msg);
      return { success: false, msg: msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: "Server error!" };
  }
};
//================== Generate 2FA QR function end ==================

//================== Verify 2FA Setup function start ==================
export const verify2FASetup = async (data_parama) => {
  apiRequest.consoleProvider("data", data_parama);
  try {
    const response = await apiRequest.post(API_BASE_URL + "/auth/verify2FASetup", data_parama, "");
    apiRequest.consoleProvider("response return");
    if (response.success === true) {
      apiRequest.consoleProvider("response success");
      const msg = response.msg;
      apiRequest.consoleProvider("message", msg);
      return { success: true, msg: msg };
    } else {
      apiRequest.consoleProvider("response false");
      const msg = response.msg;
      apiRequest.consoleProvider("message", msg);
      return { success: false, msg: msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: "Server error!" };
  }
};
//================== Verify 2FA Setup function end ==================

//================== Verify 2FA Login function start ==================
export const verify2FALogin = async (data_parama) => {
  apiRequest.consoleProvider("data", data_parama);
  try {
    const response = await apiRequest.post(API_BASE_URL + "/auth/verify2FALogin", data_parama, "");
    apiRequest.consoleProvider("response return");
    if (response.success === true) {
      apiRequest.consoleProvider("response success");
      const msg = response.msg;
      apiRequest.consoleProvider("message", msg);
      return response;
    } else {
      apiRequest.consoleProvider("response false");
      const msg = response.msg;
      apiRequest.consoleProvider("message", msg);
      return { success: false, msg: msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: "Server error!" };
  }
};
//================== Verify 2FA Login function end ==================

//==================  login function start ==================

export const signIn = async (data_parama) => {
  const { email, password, deviceType, playerId } = data_parama;
  const data = {
    action: "sign_in",
    email: email,
    password: password,
    playerId: playerId ? playerId : 123456,
    loginType: "web",
    deviceType: deviceType,
  };
  try {
    const response = await apiRequest.post(API_BASE_URL + "/auth/signIn", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      const msg = response.msg;
      const token = response.token;
      const userDetails = response?.data?.userDetails;
      localStorage.setItem(AUTH_TOKEN, token);
      localStorage.setItem("userDetails", JSON.stringify(userDetails));

      return {
        success: true,
        token: token,
        msg: msg,
        userDetails: userDetails,
      };
    } else {
      apiRequest.consoleProvider("responce false");
      const msg = response.msg;
      apiRequest.consoleProvider("message", msg);
      return { success: false, msg: msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: "Server Error" };
  }
};

//================== login function end ==================

//================== Logout function start ==================
export const signOut = createAsyncThunk("auth/logout", async () => {
  localStorage.removeItem(AUTH_TOKEN);

  localStorage.removeItem("userDetails");
  apiRequest.consoleProvider("response.logout");
  return false;
});
//================== Logout function end ==================
//================== Forgot Password function start ==================
export const forgotPassword = async (data_parama) => {
  const { email } = data_parama;
  const data = {
    action: "forgotpassword",
    email: email,
  };
  try {
    const response = await apiRequest.post(API_BASE_URL + "/auth/forgotPassword", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      const msg = response.msg;
      const userDetails = response?.data?.userDetails;
      apiRequest.consoleProvider("message", msg);
      return { success: true, msg: msg, userDetails: userDetails };
    } else {
      apiRequest.consoleProvider("responce false");
      const msg = response.msg;
      apiRequest.consoleProvider("message", msg);
      return { success: false, msg: msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: "Server error!" };
  }
};

//================== Forgot Password end ==================
//================== get profile  function start ==================
export const getProfile = async () => {
  const data_parama = {};
  try {
    const response = await apiRequest.get(API_BASE_URL + "/auth/profile", data_parama, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      const msg = response.msg;

      const userDetails = response?.data?.userDetails;
      apiRequest.consoleProvider("message", msg);
      return { success: true, msg: msg, userDetails: userDetails };
    } else {
      apiRequest.consoleProvider("responce false");
      const msg = response.msg;
      apiRequest.consoleProvider("message", msg);
      return { success: false, msg: msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: "Server error!" };
  }
};
export const fetchViewProfileData = async (data) => {
  try {
    const response = await apiRequest.get(API_BASE_URL + "/auth/userProfile", data);
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return {
        success: true,
        msg: response.msg,
        employee: response?.data?.employee,
      };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: err.message };
  }
};
//================== get profile end ==================
//================== Verify Token  function start ==================
export const verifyToken = async (data_parama) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/auth/verifyToken", data_parama, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      const msg = response.msg;

      const userDetails = response?.data?.userDetails;
      apiRequest.consoleProvider("message", msg);
      return { success: true, msg: msg, userDetails: userDetails };
    } else {
      apiRequest.consoleProvider("responce false");
      const msg = response.msg;
      apiRequest.consoleProvider("message", msg);
      return { success: false, msg: msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: "Server error!" };
  }
};

//================== get profile end ==================
//================== edit profile  function start ==================
export const editProfile = async (data_parama) => {
  apiRequest.consoleProvider("data", data_parama);
  try {
    const response = await apiRequest.postFile(API_BASE_URL + "/auth/editProfile", data_parama, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      const msg = response.msg;
      localStorage.removeItem("userDetails");
      const userDetails = response?.data?.userDetails;
      localStorage.setItem("userDetails", JSON.stringify(userDetails));
      apiRequest.consoleProvider("message", msg);
      return { success: true, msg: msg, userDetails: userDetails };
    } else {
      apiRequest.consoleProvider("responce false");
      const msg = response.msg;
      apiRequest.consoleProvider("message", msg);
      return { success: false, msg: msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: "Server error!" };
  }
};
export const editUserProfile = async (data_parama) => {
  apiRequest.consoleProvider("data", data_parama);
  try {
    const response = await apiRequest.postFile(API_BASE_URL + "/auth/editUserProfile", data_parama, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      const msg = response.msg;
      localStorage.removeItem("userDetails");
      const userDetails = response?.data?.userDetails;
      localStorage.setItem("userDetails", JSON.stringify(userDetails));
      apiRequest.consoleProvider("message", msg);
      return { success: true, msg: msg, employee: userDetails };
    } else {
      apiRequest.consoleProvider("responce false");
      const msg = response.msg;
      apiRequest.consoleProvider("message", msg);
      return { success: false, msg: msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: "Server error!" };
  }
};
export const updateProfileImage = async (data_parama) => {
  apiRequest.consoleProvider("data", data_parama);
  try {
    const response = await apiRequest.postFile(API_BASE_URL + "/auth/updateProfileImage", data_parama, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      const msg = response.msg;
      localStorage.removeItem("userDetails");
      const userDetails = response?.data?.userDetails;
      localStorage.setItem("userDetails", JSON.stringify(userDetails));
      apiRequest.consoleProvider("message", msg);
      return { success: true, msg: msg, employee: userDetails };
    } else {
      apiRequest.consoleProvider("responce false");
      const msg = response.msg;
      apiRequest.consoleProvider("message", msg);
      return { success: false, msg: msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: "Server error!" };
  }
};

//================== edit profile end ==================
//================== edit profile  function start ==================
export const updatePassword = async (data_parama) => {
  const { password, oldPassword } = data_parama;
  const data = {
    password: password,
    oldPassword: oldPassword,
  };
  apiRequest.consoleProvider("data", data);
  try {
    const response = await apiRequest.post(API_BASE_URL + "/auth/updatePassword", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      const msg = response.msg;
      apiRequest.consoleProvider("message", msg);
      return { success: true, msg: msg }; //, 'user_arr': user_arr
    } else {
      apiRequest.consoleProvider("responce false");
      const msg = response.msg;
      apiRequest.consoleProvider("message", msg);
      return { success: false, msg: msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: "Server error!" };
  }
};

//================== update password end ==================
//================== Reset password function start ==================
export const resetPassword = async (data_parama) => {
  const { uniqueId, password } = data_parama;
  const data = {
    uniqueId: uniqueId,
    password: password,
  };
  apiRequest.consoleProvider("data", data);
  try {
    const response = await apiRequest.post(API_BASE_URL + "/auth/resetPassword", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      const msg = response.msg;
      apiRequest.consoleProvider("message", msg);
      return { success: true, msg: msg };
    } else {
      apiRequest.consoleProvider("responce false");
      const msg = response.msg;
      apiRequest.consoleProvider("message", msg);
      return { success: false, msg: msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: "Server error!" };
  }
};
//================================ Dashboard =====================
export const fetchDashboardData = async (data) => {
  try {
    const response = await apiRequest.get(API_BASE_URL + "/commen/dashboard", data);
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg, data: response?.data };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: err.message };
  }
};
export const fetchPaidLeaveData = async (data) => {
  try {
    const response = await apiRequest.get(API_BASE_URL + "/commen/paidLeaveData", data);
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg, data: response?.data };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: err.message };
  }
};
//================== Attendance ==================

export const attendancePunch = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/attendance/punch", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      const msg = response.msg;
      apiRequest.consoleProvider("message", msg);
      return {
        success: true,
        msg: msg,
        attendance: response?.data?.attendance,
      };
    } else {
      apiRequest.consoleProvider("responce false");
      const msg = response.msg;
      apiRequest.consoleProvider("message", msg);
      return { success: false, msg: msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: "Server error!" };
  }
};

export const attAdminRequest = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/attendance/attAdminRequest", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      const msg = response.msg;
      apiRequest.consoleProvider("message", msg);
      return {
        success: true,
        msg: msg,
        attendance: response?.data?.attendance,
      };
    } else {
      apiRequest.consoleProvider("responce false");
      const msg = response.msg;
      apiRequest.consoleProvider("message", msg);
      return { success: false, msg: msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: "Server error!" };
  }
};
//================== fetchAttendanceDailyData ==================
export const fetchAttendanceDailyData = async (data) => {
  try {
    const response = await apiRequest.get(API_BASE_URL + "/commen/attendance/daily", data);
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return {
        success: true,
        msg: response.msg,
        attendance: response?.data?.attendance,
      };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: err.message };
  }
};
//================== fetchMyAttendancesData ==================

export const fetchMyAttendancesData = async (data) => {
  try {
    const response = await apiRequest.get(API_BASE_URL + "/commen/myattendance", data);
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return {
        success: true,
        msg: response.msg,
        attendances: response?.data?.attendances,
        monthlyExtraFreeMin: response?.data?.monthlyExtraFreeMin,
        name: response?.data?.name,
        uniqueId: response?.data?.uniqueId,
      };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: err.message };
  }
};
//================== fetchAttendancesData ==================

export const fetchAttendancesData = async (data) => {
  try {
    const response = await apiRequest.get(API_BASE_URL + "/commen/attendances", data);
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return {
        success: true,
        msg: response.msg,
        attendances: response?.data?.attendances,
      };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: err.message };
  }
};

//================== Leaves ==================

export const addLeave = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/leave/apply", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      const msg = response.msg;
      apiRequest.consoleProvider("message", msg);
      return { success: true, msg: msg, leaves: response?.data?.leaves };
    } else {
      apiRequest.consoleProvider("responce false");
      const msg = response.msg;
      apiRequest.consoleProvider("message", msg);
      return { success: false, msg: msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: "Server error!" };
  }
};

export const editLeave = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/leave/editApply", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: err.message };
  }
};
export const leaveApproveRejectStatus = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/approveRejectLeave", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: err.message };
  }
};
export const cancelLeave = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/cancelLeave", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: err.message };
  }
};
//================== fetchMyLeavesData ==================
export const fetchMyLeavesData = async (data) => {
  try {
    const response = await apiRequest.get(API_BASE_URL + "/commen/myleaves", data);
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return {
        success: true,
        msg: response.msg,
        leaves: response?.data?.leaves,
        paternityLeaveCount: response?.data?.paternityLeaveCount,
        maternityLeaveCount: response?.data?.maternityLeaveCount,
        paidLeaveCount: response?.data?.paidLeaveCount,
        name: response?.data?.name,
        uniqueId: response?.data?.uniqueId,
      };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: err.message };
  }
};
//================== fetchLeavesData ==================

export const fetchLeavesData = async (data) => {
  try {
    const response = await apiRequest.get(API_BASE_URL + "/commen/leaves", data);
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return {
        success: true,
        msg: response.msg,
        leaves: response?.data?.leaves,
      };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: err.message };
  }
};
export const fetchUsersData = async (data) => {
  try {
    const response = await apiRequest.get(API_BASE_URL + "/commen/getUsersAll", data);
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return {
        success: true,
        msg: response.msg,
        employees: response?.data?.employees,
      };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: err.message };
  }
};
export const fetchNotificationEmployeeData = async (data) => {
  try {
    const response = await apiRequest.get(API_BASE_URL + "/commen/getNotificationEmployeeAll", data);
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return {
        success: true,
        msg: response.msg,
        employees: response?.data?.employees,
      };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: err.message };
  }
};
export const sendAnnouncement = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/sendAnnouncement", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      const msg = response.msg;
      apiRequest.consoleProvider("message", msg);
      return { success: true, msg: msg };
    } else {
      apiRequest.consoleProvider("responce false");
      const msg = response.msg;
      apiRequest.consoleProvider("message", msg);
      return { success: false, msg: msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: "Server error!" };
  }
};
//================== RegularizationRequest ==================

export const addRegularizationRequest = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/regularization/addRegularizationRequest", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      const msg = response.msg;
      apiRequest.consoleProvider("message", msg);
      return { success: true, msg: msg, leaves: response?.data?.leaves };
    } else {
      apiRequest.consoleProvider("responce false");
      const msg = response.msg;
      apiRequest.consoleProvider("message", msg);
      return { success: false, msg: msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: "Server error!" };
  }
};

export const editRegularizationRequest = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/regularization/editRegularizationRequest", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: err.message };
  }
};
export const approveRejectStatusRegularizationRequest = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/regularization/approveRejectStatusRegularizationRequest", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: err.message };
  }
};
export const cancelRegularizationRequest = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/regularization/cancelRegularizationRequest", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: err.message };
  }
};
//================== fetchMyLeavesData ==================
export const fetchMyRegularizationRequestData = async (data) => {
  try {
    const response = await apiRequest.get(API_BASE_URL + "/commen/regularization/myRegularizationRequest", data);
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return {
        success: true,
        msg: response.msg,
        regularizations: response?.data?.regularizations,
        name: response?.data?.name,
        uniqueId: response?.data?.uniqueId,
      };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: err.message };
  }
};
//================== fetchLeavesData ==================

export const fetchRegularizationRequestsData = async (data) => {
  try {
    const response = await apiRequest.get(API_BASE_URL + "/commen/regularization/regularizationRequests", data);
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return {
        success: true,
        msg: response.msg,
        regularizations: response?.data?.regularizations,
      };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: err.message };
  }
};

export const UploadProfileImage = async (data_parama) => {
  try {
    const response = await apiRequest.postFile(API_BASE_URL_FILE, data_parama, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      const msg = response.msg;
      return { success: true, msg: msg, fileName: response.fileName };
    } else {
      const msg = response.msg;
      return { success: false, msg: msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: "Server error!" };
  }
};
//================================ Holidays =====================
export const fetchHolidaysData = async (data) => {
  try {
    const response = await apiRequest.get(API_BASE_URL + "/commen/holidays", data);
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return {
        success: true,
        msg: response.msg,
        holidays: response?.data?.holidays,
      };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: err.message };
  }
};
export const fetchHolidaysDataByShiftId = async (data) => {
  try {
    const response = await apiRequest.get(API_BASE_URL + "/commen/holidaysByShiftId", data);
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return {
        success: true,
        msg: response.msg,
        holidays: response?.data?.holidays,
      };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: err.message };
  }
};

//                                          ================================ Holiday=====================
export const addHoliday = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/addHoliday", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: err.message };
  }
};

export const editHoliday = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/editHoliday", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: err.message };
  }
};
export const holidayActiveDeactiveStatus = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/activeDeactiveHoliday", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: err.message };
  }
};
export const deleteHoliday = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/deleteHoliday", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: err.message };
  }
};
export const holidayCompoffStatus = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/holidayCompoffStatus", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: err.message };
  }
};
//================================ Dashboard =====================
export const fetchNotificationData = async (data) => {
  try {
    const response = await apiRequest.get(API_BASE_URL + "/commen/myNotification", data);
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg, data: response?.data };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: err.message };
  }
};
export const fetchNotificationCountData = async (data) => {
  try {
    const response = await apiRequest.get(API_BASE_URL + "/commen/myNotificationCount", data);
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg, data: response?.data };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: err.message };
  }
};
export const deleteNotification = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/deleteNotification", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: err.message };
  }
};
export const readNotification = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/readNotification", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: err.message };
  }
};
export const clearNotification = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/clearNotification", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: err.message };
  }
};
//================================ unit =====================
export const fetchUnitsData = async (data) => {
  try {
    const response = await apiRequest.get(API_BASE_URL + "/commen/units", data);
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg, units: response?.data?.units };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: err.message };
  }
};
export const fetchExportAttendance = async (data) => {
  try {
    const response = await apiRequest.getExport(API_BASE_URL + "/commen/export/attendance", data, "");

    apiRequest.consoleProvider("responce returnresponse", response);
    if (response.success === false) {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg, response: response };
    }
  } catch (err) {
    apiRequest.consoleProvider("Errordsfsdfsfssfdsffds", err.message);
    return { success: false, msg: err.message };
  }
};
export const fetchExportAttendanceBreak = async (data) => {
  try {
    const response = await apiRequest.getExport(API_BASE_URL + "/commen/export/attendance/break", data, "");

    apiRequest.consoleProvider("responce returnresponse", response);
    if (response.success === false) {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg, response: response };
    }
  } catch (err) {
    apiRequest.consoleProvider("Errordsfsdfsfssfdsffds", err.message);
    return { success: false, msg: err.message };
  }
};
export const fetchExportAttendanceFinal = async (data) => {
  try {
    const response = await apiRequest.getExport(API_BASE_URL + "/commen/export/attendanceFinal", data, "");

    apiRequest.consoleProvider("responce returnresponse", response);
    if (response.success === false) {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg, response: response };
    }
  } catch (err) {
    apiRequest.consoleProvider("Errordsfsdfsfssfdsffds", err.message);
    return { success: false, msg: err.message };
  }
};
export const fetchExportAttendanceLog = async (data) => {
  try {
    const response = await apiRequest.getExport(API_BASE_URL + "/commen/export/exportAttendanceLog", data, "");

    apiRequest.consoleProvider("responce returnresponse", response);
    if (response.success === false) {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg, response: response };
    }
  } catch (err) {
    apiRequest.consoleProvider("Errordsfsdfsfssfdsffds", err.message);
    return { success: false, msg: err.message };
  }
};
export const fetchExportDailyAttendance = async (data) => {
  try {
    const response = await apiRequest.getExport(API_BASE_URL + "/commen/export/dailyAttendance", data, "");

    apiRequest.consoleProvider("responce returnresponse", response);
    if (response.success === false) {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg, response: response };
    }
  } catch (err) {
    apiRequest.consoleProvider("Errordsfsdfsfssfdsffds", err.message);
    return { success: false, msg: err.message };
  }
};

//================== ReimbursementRequest ==================

export const addReimbursementRequest = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/reimbursement/addReimbursementRequest", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      const msg = response.msg;
      apiRequest.consoleProvider("message", msg);
      return {
        success: true,
        msg: msg,
        reimbursement: response?.data?.reimbursement,
      };
    } else {
      apiRequest.consoleProvider("responce false");
      const msg = response.msg;
      apiRequest.consoleProvider("message", msg);
      return { success: false, msg: msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: "Server error!" };
  }
};

export const editReimbursementRequest = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/reimbursement/editReimbursementRequest", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: err.message };
  }
};
export const approveRejectStatusReimbursementRequest = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/reimbursement/approveRejectStatusReimbursementRequest", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: err.message };
  }
};
export const updatePayStatusReimbursementRequest = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/reimbursement/updatePayStatusReimbursementRequest", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: err.message };
  }
};

export const cancelReimbursementRequest = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/reimbursement/cancelReimbursementRequest", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: err.message };
  }
};
//================== MyReimbursementRequestsData ==================
export const fetchMyReimbursementRequestData = async (data) => {
  try {
    const response = await apiRequest.get(API_BASE_URL + "/commen/reimbursement/myReimbursementRequest", data);
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return {
        success: true,
        msg: response.msg,
        reimbursements: response?.data?.reimbursements,
        name: response?.data?.name,
        uniqueId: response?.data?.uniqueId,
      };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: err.message };
  }
};
//================== ReimbursementRequestsData ==================

export const fetchReimbursementRequestsData = async (data) => {
  try {
    const response = await apiRequest.get(API_BASE_URL + "/commen/reimbursement/reimbursementRequests", data);
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return {
        success: true,
        msg: response.msg,
        reimbursements: response?.data?.reimbursements,
      };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: err.message };
  }
};
//================== IncentiveRequest ==================

export const addIncentiveRequest = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/incentive/addIncentiveRequest", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      const msg = response.msg;
      apiRequest.consoleProvider("message", msg);
      return { success: true, msg: msg, incentive: response?.data?.incentive };
    } else {
      apiRequest.consoleProvider("responce false");
      const msg = response.msg;
      apiRequest.consoleProvider("message", msg);
      return { success: false, msg: msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: "Server error!" };
  }
};

export const editIncentiveRequest = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/incentive/editIncentiveRequest", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: err.message };
  }
};
export const approveRejectStatusIncentiveRequest = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/incentive/approveRejectStatusIncentiveRequest", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: err.message };
  }
};
export const updatePayStatusIncentiveRequest = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/incentive/updatePayStatusIncentiveRequest", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: err.message };
  }
};
export const cancelIncentiveRequest = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/incentive/cancelIncentiveRequest", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: err.message };
  }
};
//================== MyIncentiveRequestsData ==================
export const fetchMyIncentiveRequestData = async (data) => {
  try {
    const response = await apiRequest.get(API_BASE_URL + "/commen/incentive/myIncentiveRequest", data);
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return {
        success: true,
        msg: response.msg,
        incentives: response?.data?.incentives,
        name: response?.data?.name,
        uniqueId: response?.data?.uniqueId,
      };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: err.message };
  }
};
//================== IncentiveRequestsData ==================

export const fetchIncentiveRequestsData = async (data) => {
  try {
    const response = await apiRequest.get(API_BASE_URL + "/commen/incentive/incentiveRequests", data);
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return {
        success: true,
        msg: response.msg,
        incentives: response?.data?.incentives,
      };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: err.message };
  }
};
//================== CompoffRequest ==================

export const addCompoffRequest = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/compoff/addCompoffRequest", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      const msg = response.msg;
      apiRequest.consoleProvider("message", msg);
      return { success: true, msg: msg, compoff: response?.data?.compoff };
    } else {
      apiRequest.consoleProvider("responce false");
      const msg = response.msg;
      apiRequest.consoleProvider("message", msg);
      return { success: false, msg: msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: "Server error!" };
  }
};

export const editCompoffRequest = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/compoff/editCompoffRequest", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: err.message };
  }
};
export const approveRejectStatusCompoffRequest = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/compoff/approveRejectStatusCompoffRequest", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: err.message };
  }
};
export const cancelCompoffRequest = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/compoff/cancelCompoffRequest", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: err.message };
  }
};
//================== MyCompoffRequestsData ==================
export const fetchMyCompoffRequestData = async (data) => {
  try {
    const response = await apiRequest.get(API_BASE_URL + "/commen/compoff/myCompoffRequest", data);
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return {
        success: true,
        msg: response.msg,
        compoffs: response?.data?.compoffs,
        name: response?.data?.name,
        uniqueId: response?.data?.uniqueId,
      };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: err.message };
  }
};
//================== CompoffRequestsData ==================

export const fetchCompoffRequestsData = async (data) => {
  try {
    const response = await apiRequest.get(API_BASE_URL + "/commen/compoff/compoffRequests", data);
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return {
        success: true,
        msg: response.msg,
        compoffs: response?.data?.compoffs,
      };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: err.message };
  }
};
//   ================================ IncentivePolicy=====================
export const addIncentivePolicy = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/addShiftIncentivePolicy", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: err.message };
  }
};

export const editIncentivePolicy = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/editShiftIncentivePolicy", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: err.message };
  }
};
export const incentivePolicyActiveDeactiveStatus = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/activeDeactiveShiftIncentivePolicy", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: err.message };
  }
};
export const deleteIncentivePolicy = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/deleteShiftIncentivePolicy", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: err.message };
  }
};
//================================ fetchShiftsByUnitData =====================
export const fetchShiftsByUnitData = async (data) => {
  try {
    const response = await apiRequest.get(API_BASE_URL + "/commen/shiftsByUnit", data);
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return {
        success: true,
        msg: response.msg,
        shifts: response?.data?.shifts,
      };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: err.message };
  }
};
export const fetchShiftsData = async (data) => {
  try {
    const response = await apiRequest.get(API_BASE_URL + "/commen/shiftsData", data);
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return {
        success: true,
        msg: response.msg,
        shifts: response?.data?.shifts,
      };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: err.message };
  }
};
//================================ fetchIncentivePolicysData =====================

export const fetchIncentivePolicys = async (data) => {
  try {
    const response = await apiRequest.get(API_BASE_URL + "/commen/incentivePolicys", data);
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return {
        success: true,
        msg: response.msg,
        policys: response?.data?.policys,
      };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: err.message };
  }
};
export const fetchIncentivePolicysData = async (data) => {
  try {
    const response = await apiRequest.get(API_BASE_URL + "/commen/shiftIncentivePolicys", data);
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return {
        success: true,
        msg: response.msg,
        policys: response?.data?.policys,
      };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: err.message };
  }
};
export const fetchDevices = async (data) => {
  try {
    const response = await apiRequest.get(API_BASE_URL + "/commen/devices", data);
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return {
        success: true,
        msg: response.msg,
        devices: response?.data?.devices,
      };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: err.message };
  }
};
export const addDevice = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/addDevice", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: err.message };
  }
};

export const editDevice = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/editDevice", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: err.message };
  }
};
export const deviceActiveDeactiveStatus = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/activeDeactiveDevice", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: err.message };
  }
};
export const deleteDevice = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/deleteDevice", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: err.message };
  }
};
export const fetchRolesData = async () => {
  const data = {};
  try {
    const response = await apiRequest.get(API_BASE_URL + "/commen/roles", data);
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg, roles: response?.data?.roles };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: err.message };
  }
};
//================== EmployeeInPayrolls ==================

export const addEmployeeInPayroll = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/employeeInPayroll/apply", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      const msg = response.msg;
      apiRequest.consoleProvider("message", msg);
      return {
        success: true,
        msg: msg,
        employeeInPayrolls: response?.data?.employeeInPayrolls,
      };
    } else {
      apiRequest.consoleProvider("responce false");
      const msg = response.msg;
      apiRequest.consoleProvider("message", msg);
      return { success: false, msg: msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: "Server error!" };
  }
};

export const editEmployeeInPayroll = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/employeeInPayroll/editApply", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: err.message };
  }
};
export const employeeInPayrollApproveRejectStatus = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/approveRejectEmployeeInPayroll", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: err.message };
  }
};
export const cancelEmployeeInPayroll = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/cancelEmployeeInPayroll", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: err.message };
  }
};
//================== fetchMyEmployeeInPayrollsData ==================
export const fetchMyEmployeeInPayrollsData = async (data) => {
  try {
    const response = await apiRequest.get(API_BASE_URL + "/commen/myemployeeInPayrolls", data);
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return {
        success: true,
        msg: response.msg,
        employeeInPayrolls: response?.data?.employeeInPayrolls,
        paternityEmployeeInPayrollCount: response?.data?.paternityEmployeeInPayrollCount,
        maternityEmployeeInPayrollCount: response?.data?.maternityEmployeeInPayrollCount,
        paidEmployeeInPayrollCount: response?.data?.paidEmployeeInPayrollCount,
        name: response?.data?.name,
        uniqueId: response?.data?.uniqueId,
      };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: err.message };
  }
};
//================== fetchEmployeeInPayrollsData ==================

export const fetchEmployeeInPayrollsData = async (data) => {
  try {
    const response = await apiRequest.get(API_BASE_URL + "/commen/employeeInPayrolls", data);
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return {
        success: true,
        msg: response.msg,
        employeeInPayrolls: response?.data?.employeeInPayrolls,
      };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: err.message };
  }
};

//================== fetchproccessData ==================

export const fetchProccesssData = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/proccess", data);
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return {
        success: true,
        msg: response.msg,
        proccesss: response?.data?.proccess,
        ctcsp: response?.data?.ctcsp,
      };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: err.message };
  }
};
export const fetchCustomData = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/custom", data);
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return response;
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: err.message };
  }
};
export const addProcess = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/addProccess", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      const msg = response.msg;
      apiRequest.consoleProvider("message", msg);
      return { success: true, msg: msg, proccesss: response?.data?.proccesss };
    } else {
      apiRequest.consoleProvider("responce false");
      const msg = response.msg;
      apiRequest.consoleProvider("message", msg);
      return { success: false, msg: msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: "Server error!" };
  }
};

//================== fetchmonthlyproccessData ==================

export const fetchMonthlyProccesssData = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/monthlyProccesss", data);
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return {
        success: true,
        msg: response.msg,
        monthlyProccesss: response?.data?.monthlyProccess,
        ctcsp: response?.data?.ctcsp,
      };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: err.message };
  }
};

export const addMonthlyProccess = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/addMonthlyProccess", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      const msg = response.msg;
      apiRequest.consoleProvider("message", msg);
      return {
        success: true,
        msg: msg,
        monthlyProccesss: response?.data?.monthlyProccesss,
      };
    } else {
      apiRequest.consoleProvider("responce false");
      const msg = response.msg;
      apiRequest.consoleProvider("message", msg);
      return { success: false, msg: msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: "Server error!" };
  }
};
//================== MyReimbursementRequestsData ==================
export const fetchMyMonthlyProccess = async (data) => {
  try {
    const response = await apiRequest.get(API_BASE_URL + "/commen/myMonthlyProccess", data);
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return {
        success: true,
        msg: response.msg,
        monthlyProccesss: response?.data?.monthlyProccesss,
        name: response?.data?.name,
        uniqueId: response?.data?.uniqueId,
      };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: err.message };
  }
};
export  const fetchRegistrationsData = async (data) => {
  try {
    const response = await apiRequest.get(API_BASE_URL + "/commen/registrations", data);
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return {
        success: true,
        msg: response.msg,
        registrations: response?.data?.registrations,
      };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: err.message };
  }
};
export  const fetchRegistrationData = async (data) => {
  try {
    const response = await apiRequest.get(API_BASE_URL + "/commen/registration", data);
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return {
        success: true,
        msg: response.msg,
        registration: response?.data?.registration,
      };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: err.message };
  }
};
export const deleteRegistration = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/deleteRegistration", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: err.message };
  }
};
export const approveRegistration = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/approveRegistration", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: err.message };
  }
};

export const updateRegistration = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/updateRegistration", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: err.message };
  }
};
export const addRegistration = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/addRegistration", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: err.message };
  }
};
export const editRegistration = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/editRegistration", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: err.message };
  }
};
export const fetchUnitShiftsData = async (data) => {
  try {
    const response = await apiRequest.get(API_BASE_URL + "/commen/unitShifts", data);
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return {
        success: true,
        msg: response.msg,
        shifts: response?.data?.shifts,
      };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: err.message };
  }
};
export const fetchUnitDepartmentsData = async (data) => {
  try {
    const response = await apiRequest.get(API_BASE_URL + "/commen/unitDepartments", data);
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return {
        success: true,
        msg: response.msg,
        departments: response?.data?.departments,
      };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: err.message };
  }
};
export const fetchUnitTeamsData = async (data) => {
  try {
    const response = await apiRequest.get(API_BASE_URL + "/commen/unitTeams", data);
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg, teams: response?.data?.teams };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: err.message };
  }
};

export const fetchReportingManagersData = async (data) => {
  try {
    const response = await apiRequest.get(API_BASE_URL + "/commen/getReportingManagerAll", data);
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return {
        success: true,
        msg: response.msg,
        employees: response?.data?.employees,
      };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: err.message };
  }
};
export const fetchPermissionsData = async (data) => {
  try {
    const response = await apiRequest.get(API_BASE_URL + "/commen/permissions", data);
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return {
        success: true,
        msg: response.msg,
        permissions: response?.data?.permissions,
      };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: err.message };
  }
};
export const fetchHolidaysTemp = async (data) => {
  try {
    const response = await apiRequest.get(API_BASE_URL + "/commen/holidaysTemp", data);
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return {
        success: true,
        msg: response.msg,
        holidays: response?.data?.holidays,
      };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error", err.message);
    return { success: false, msg: err.message };
  }
};
export const addHolidayBulk = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/addHolidayBulk", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: err.message };
  }
};

export const addHolidayTemp = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/addHolidayTemp", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: err.message };
  }
};

export const editHolidayTemp = async (data) => {
  try {
    const response = await apiRequest.post(API_BASE_URL + "/commen/editHolidayTemp", data, "");
    apiRequest.consoleProvider("responce return");
    if (response.success === true) {
      apiRequest.consoleProvider("responce sucess");
      return { success: true, msg: response.msg };
    } else {
      apiRequest.consoleProvider("responce false");
      return { success: false, msg: response.msg };
    }
  } catch (err) {
    apiRequest.consoleProvider("Error");
    return { success: false, msg: err.message };
  }
};
// export const fetchExportMonthlyProccess = async (data) => {
//   try {
//     const response = await apiRequest.getExport(API_BASE_URL + "/commen/export/monthlyProccesss", data, "");

//     apiRequest.consoleProvider("responce returnresponse", response);
//     if (response.success === false) {
//       apiRequest.consoleProvider("responce false");
//       return { success: false, msg: response.msg };
//     } else {
//       apiRequest.consoleProvider("responce sucess");
//       return { success: true, msg: response.msg, response: response };
//     }
//   } catch (err) {
//     apiRequest.consoleProvider("Errordsfsdfsfssfdsffds", err.message);
//     return { success: false, msg: err.message };
//   }
// };
//====================================== export Proccess ==========================================
// export const fetchExportProccess = async (data) => {
//   try {
//     const response = await apiRequest.getExport(API_BASE_URL + "/commen/export/proccess", data, "");

//     apiRequest.consoleProvider("responce returnresponse", response);
//     if (response.success === false) {
//       apiRequest.consoleProvider("responce false");
//       return { success: false, msg: response.msg };
//     } else {
//       apiRequest.consoleProvider("responce sucess");
//       return { success: true, msg: response.msg, response: response };
//     }
//   } catch (err) {
//     apiRequest.consoleProvider("Errordsfsdfsfssfdsffds", err.message);
//     return { success: false, msg: err.message };
//   }
// };
// export const fetchExportProccessLog = async (data) => {
//   try {
//     const response = await apiRequest.getExport(API_BASE_URL + "/commen/export/exportProccessLog", data, "");

//     apiRequest.consoleProvider("responce returnresponse", response);
//     if (response.success === false) {
//       apiRequest.consoleProvider("responce false");
//       return { success: false, msg: response.msg };
//     } else {
//       apiRequest.consoleProvider("responce sucess");
//       return { success: true, msg: response.msg, response: response };
//     }
//   } catch (err) {
//     apiRequest.consoleProvider("Errordsfsdfsfssfdsffds", err.message);
//     return { success: false, msg: err.message };
//   }
// };
// export const fetchExportDailyProccess = async (data) => {
//   try {
//     const response = await apiRequest.getExport(API_BASE_URL + "/commen/export/dailyProccess", data, "");

//     apiRequest.consoleProvider("responce returnresponse", response);
//     if (response.success === false) {
//       apiRequest.consoleProvider("responce false");
//       return { success: false, msg: response.msg };
//     } else {
//       apiRequest.consoleProvider("responce sucess");
//       return { success: true, msg: response.msg, response: response };
//     }
//   } catch (err) {
//     apiRequest.consoleProvider("Errordsfsdfsfssfdsffds", err.message);
//     return { success: false, msg: err.message };
//   }
// };
//================== reset password end ==================
//================== create function start ==================

// export const signUp = createAsyncThunk('auth/register', async (data, { rejectWithValue }) => {
// 	const { email, password } = data
// 	try {
// 		const token = '';
// 		//const response = await AuthService.register({email, password})
// 		//const token = response?.data?.token;
// 		localStorage.setItem(AUTH_TOKEN, token);
// 		return token;
// 	} catch (err) {
// 		return rejectWithValue(err.response?.data?.message || 'Error')
// 	}
// })

//================== create function end ==================
